import Element from "./index";
import { RouteType } from "routes/types";

const route: RouteType = {
  id: 1210,
  parentId: 1200,
  name: "ProductIntroduction",
  label: "Platform Introduction",
  path: "/",
  // icon: "lightbulb",
  element: Element,
  footer: true,
  user: false,
  admin: false,
  hidden: false,
};

export default route;
